<template>
  <div style="box-shadow: rgba(0, 0, 0, 0.5) 3px -1px 4px 2px;z-index: 100;position: relative;">
    <span style="position: absolute;margin-top: 6px;color: white;
    z-index: 1000;margin-left: 160px;font-size: 13px;">V{{version}}
    <span style="margin-left:5px;cursor: pointer;" @mouseenter="kefuinfo(true)" @mouseleave="kefuinfo(false)">客服</span>
      <div style="left: -27px;" v-if="kfweixin">
          <img src="//s0.5118img.com/assist/images/kf_5118.jpg">
      </div>
    </span>
    <header>
			<span style="background: none;" @click="retract">收起
				<img src="../assets/image/ri_ico.png" style="vertical-align: 1px;display: inline-block;">
			</span>
      <div class="user-box " :class="{logged}" @click="showLogin">
        <img :src="userInfo.avatar||require(`../assets/image/user/user.png`)" class="head-img"
             :onerror="`this.src='${require(`../assets/image/user/user.png`)}'`">
        <ul>
          <li><a href="https://account.5118.com/signin/invitation " target="_blank">个人中心</a></li>
          <li><a href="https://account.5118.com/signin/logout" target="_blank">退出</a></li>
        </ul>
      </div>
    </header>
    <div class="update-tips" v-if="showUpTip">
      发现有新版本更新，去<a href="https://tool.5118.com/download?operation=update#type-tab" target="_blank"
                   style="color: white;text-decoration: underline;">升级更新</a>
      <a href="javascript:" style="float: right;font-size: 20px;color: white;margin-right: 10px;"
         @click="showUpTip = false">×</a>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
        return{
            kfweixin:false
        }
    },
    computed: {
      showUpTip: {
        get() {
          return this.$store.state.header.showUpTip
        }, set(val) {
          this.$store.state.header.showUpTip = val
        }
      },
      logged: {
        get() {
          return this.$store.state.user.logged
        }
      },
      userInfo: {
        get() {
          return this.$store.state.user.userInfo
        }
      },
      version: {
        get(){
          return this.$store.state.menu.version
        },
        set(val){
          this.$store.state.menu.version = val
        }
      },
      loginBox:{
        get() {
          return this.$store.state.header.loginBox
        }, set(val) {
          this.$store.state.header.loginBox = val
        }
      }
    },
    mounted() {
      this.listenNewVersion();
    },
    methods: {
      showLogin() {
        if (!this.logged) {
          if(this.loginBox){
            this.loginBox.close();
            this.loginBox = null
          }
          this.loginBox = this.$loginBox();
        }
      },
      retract() {
        this.$messenger.addTarget(window.parent, 'parent');
        this.$messenger.targets['parent'].send("Show_Main_List_Message");
      },
      listenNewVersion() {
        this.$messenger.listen("_5118_Is_NewVersion", (msg) => {
          if (msg === 'new') {
            this.showUpTip = true;
          }
        });
      },
      kefuinfo(m){
        m===true?this.kfweixin=true:this.kfweixin=false;
      }
    }
  }
</script>
<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  header {
    background: #166df1 url(../assets/image/5118_Main_Img.png) no-repeat 10px 7px;
    line-height: @header-height;
    height: @header-height;
    position: relative;
    box-sizing: border-box;
    font-size: 12px;

    z-index: 999;
    font-family: Lato, sans-serif;
    margin: 0 auto;
    .user-box {
      display: inline-block;
      float: right;
      margin-right: 7px;
      position: relative;
      .head-img {
        vertical-align: -5px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        cursor: pointer
      }
      ul {
        padding: 0;
        position: absolute;
        background-color: white;
        box-shadow: #eaeaea 0 1px 6px 0;
        left: -30px;
        width: 110px;
        display: none;
        top: 25px;
        li {
          list-style: none;
          display: block;
          width: 100%;
          a {
            display: block;
            color: #999;
            padding: 0 15px;
            line-height: 35px;
            font-size: 14px;
            &:hover {
              background-color: #ebf5ff;
            }
          }
        }
      }

      &.logged {
        &:hover {
          ul {
            display: block;
          }
        }
      }
    }
    span {
      float: right;
      display: inline-block;
      cursor: pointer;
      line-height: 30px;
      color: white;
      font-family: Lato, sans-serif;
      font-size: 12px;
      font-weight: 500;
      border-left: 1px solid rgba(204, 204, 204, 0.4);
      padding: 0 10px;
    }
  }

  .update-tips {
    line-height: @up-tip-height;
    color: white;
    padding-left: 10px;
    background-color: orange;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue